export default{
  GetQueryString(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
  },
  ImgUpload(btn, cb){
    //上传图片
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/photo"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = () => {
      cb(videoPhotoOption.fileUrl)
    }; //上传成功回调方法
    videoPhotoOption.fileType = "jpg,jpeg,png"; //文件类型
    videoPhotoOption.maxFileSize = "100mb";  //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  VideoUpload(btn, cb){
    //上传视频
    var videoPhotoOption = {};
    videoPhotoOption.test = 'abc';
    videoPhotoOption.uploadParentPath = "sd/video"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = () => {
      cb(videoPhotoOption.fileUrl)
    }; //上传成功回调方法
    videoPhotoOption.fileType = "mp4"; //文件类型
    videoPhotoOption.maxFileSize = "500mb";  //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  AudioUpload(btn, cb){
    //上传视频
    var videoPhotoOption = {};
    videoPhotoOption.test = 'abc';
    videoPhotoOption.uploadParentPath = "sd/video"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = () => {
      cb(videoPhotoOption.fileUrl)
    }; //上传成功回调方法
    videoPhotoOption.fileType = "mp3,mp4"; //文件类型
    videoPhotoOption.maxFileSize = "500mb";  //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  pdfUpload(btn, cb){
    //上传pdf
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/pdf"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = () => {
      cb(videoPhotoOption.fileUrl)
    }; //上传成功回调方法
    videoPhotoOption.fileType = "pdf"; //文件类型
    videoPhotoOption.maxFileSize = "100mb";  //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  fileUpload(btn, cb){
    //上传文件
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/photo"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = () => {
      console.log(videoPhotoOption)
      cb(videoPhotoOption.fileUrl)
    }; //上传成功回调方法
    videoPhotoOption.fileType = "jpg,jpeg,png,doc,docx"; //文件类型
    videoPhotoOption.maxFileSize = "100mb";  //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  getImgByPdf(el,url){
    $("#"+el).empty();
    // var url = 'http://qvbian-web.oss-cn-shanghai.aliyuncs.com/contract/sx20180801000005.pdf';
    url = url+"?"+Math.random();

    PDFJS.workerSrc = '/static/pdf/pdf.worker.js';
    PDFJS.getDocument(url).then((pdf)=>{
      let pageSize = pdf.numPages;

      for(var i = 1; i <= pageSize; i++) {
        let canvas = document.createElement('canvas');
        // canvas.id = "pageNum" + i;
        $("#"+el).append(canvas);
        let context = canvas.getContext('2d');
        let scale = 2;
        pdf.getPage(i).then((page)=>{
          let viewport = page.getViewport(scale);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style.width = "100%";
          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          page.render(renderContext);
        });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/util/util.js